import { render, staticRenderFns } from "./CoContentPreview.vue?vue&type=template&id=0deee2c4&"
import script from "./CoContentPreview.vue?vue&type=script&lang=ts&"
export * from "./CoContentPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports